import type { WorkerEvent } from "@/types/webWorkers";

export class TypedWorker {
  private worker: Worker;

  constructor(worker: Worker) {
    this.worker = worker;
  }

  postMessage<K extends keyof WorkerEvent>(
    type: K,
    payload: WorkerEvent[K]["request"],
  ) {
    this.worker.postMessage({ type, payload });
  }

  onMessage<K extends keyof WorkerEvent>(
    callback: (
      event: MessageEvent<{
        type: K;
        payload: WorkerEvent[K]["response"];
      }>,
    ) => void,
  ) {
    this.worker.addEventListener("message", (event) => {
      callback(event);
    });
  }
}
